import SubsetCandidateScreen from '@/components/PortfolioOptimization/Accordions/OptimizationGoalAndConstraints/SubsetCandidateScreen'
import { Close } from '@mui/icons-material'
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
} from '@mui/material'
import React, { useCallback } from 'react'

interface SubsetCandidateScreenModalProps {
  isOpen: boolean
  onClose: () => void
  isSubset: boolean
  onApply?: (criteriaName: string, criteriaData?: any) => void
  filterTo?: string // Filter parameter for screening items (S, E, P, V)
}

const SubsetCandidateScreenModal: React.FC<SubsetCandidateScreenModalProps> = ({
  isOpen,
  onClose,
  isSubset,
  onApply,
  filterTo,
}) => {
  const handleClose = useCallback(
    (event: any, reason: string) => {
      // Prevent closing the modal when backdrop/outside modal is clicked
      if (reason && reason === 'backdropClick') return
      onClose()
    },
    [onClose],
  )
  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth='lg' fullWidth>
      <DialogTitle>
        <Box display='flex' alignItems='center'>
          <Box flexGrow={1} sx={{ fontSize: '1.25rem' }}>
            Define Subset
          </Box>
          <Box>
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <SubsetCandidateScreen isSubset={isSubset} onClose={onClose} onApply={onApply} filterTo={filterTo} />
      </DialogContent>
    </Dialog>
  )
}

export default SubsetCandidateScreenModal
